import React from 'react';
import { Tooltip, Divider } from 'antd';
import { renderIconDownload } from '../helpers';

const Download = ({ pos, report, download }) => {
  let { Icon, title } = renderIconDownload(report);
  return (    
    <>
        {pos !== 0 ? <Divider type='vertical' /> : null}
        <div onClick={download.bind(this, report.url)}>
            <Tooltip title={title}>
              {Icon}
            </Tooltip>
        </div>
    </>
  );
};

export default Download;
